import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 mb-6 text-center">
            {aboutData.title}
          </h2>
          <div className="space-y-4">
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.desc1}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.desc2}
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
              {aboutData.desc3}
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-10">
            <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200/70">
              <div className="text-2xl font-heading font-bold text-primary-500 mb-1">2016</div>
              <div className="text-xs text-foreground-500">创立年份</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200/70">
              <div className="text-2xl font-heading font-bold text-accent-500 mb-1">1000万+</div>
              <div className="text-xs text-foreground-500">累计用户</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200/70">
              <div className="text-2xl font-heading font-bold text-primary-500 mb-1">10000+</div>
              <div className="text-xs text-foreground-500">影视资源</div>
            </div>
            <div className="bg-background-50 rounded-xl p-5 text-center border border-background-200/70">
              <div className="text-2xl font-heading font-bold text-accent-500 mb-1">7×24</div>
              <div className="text-xs text-foreground-500">更新保障</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}